import * as React from "react";
import { Col, Row, Grid}  from "react-bootstrap";
import { EstructuraEmpresa, EstructuraSuraEmpresa } from "../modelo/EstructuraEmpresa";
import ContenidoPestañaEmpresa from "./ContenidoPestañaEmpresa";

export default class InformacionBasicaEmpresa extends React.Component<InformacionBasicaEmpresaProps, any> {

    render() {
        return(
            <div>
                <ContenidoPestañaEmpresa
                    estructuraEmpresa={this.props.estructuraEmpresa}
                    estructuraSuraEmpresa={this.props.estructuraSuraEmpresa}
                    tituloCabecera={`Datos Básicos Sistema de Afiliación Transaccional - Consecutivo ${this.props.consecutivoConsulta}`}
                    contenido={this.renderContenido()}
                />
            </div>
        );
    }

    renderContenido() {
        const {estructuraEmpresa} = this.props;
        const datosBasicos = {
            tipoPersona: estructuraEmpresa.tipoPersona ? (`(${estructuraEmpresa.tipoPersona}) ${estructuraEmpresa.tipoPersona === 'N' ? 'Natural' : 'Juridica'}`) : '-',
            naturalezaJuridica: estructuraEmpresa.naturalezaJuridica ? estructuraEmpresa.naturalezaJuridica : '-',
            codigoActividadEconomica: estructuraEmpresa.codigoActividadEconomica ? estructuraEmpresa.codigoActividadEconomica : '-',
            tipoAportante: estructuraEmpresa.tipoAportante ? estructuraEmpresa.tipoAportante : '-',
            claseAportante: estructuraEmpresa.claseAportante ?  estructuraEmpresa.claseAportante : '-',
            correoElectronico: estructuraEmpresa.correoElectronico ?  estructuraEmpresa.correoElectronico : '-',
            RL: {
                tipoDocumento: estructuraEmpresa.tipoDocumentoRepresentante ? estructuraEmpresa.tipoDocumentoRepresentante : '-',
                numeroDocumento: estructuraEmpresa.numeroDocumentoRepresentante ? estructuraEmpresa.numeroDocumentoRepresentante : '-',
                primerNombre: estructuraEmpresa.primerNombreRepresentante ? estructuraEmpresa.primerNombreRepresentante : '-',
                segundoNombre: estructuraEmpresa.segundoNombreRepresentante ? estructuraEmpresa.segundoNombreRepresentante : '-',
                primerApellido: estructuraEmpresa.primerApellidoRepresentante ? estructuraEmpresa.primerApellidoRepresentante : '-',
                segundoApellido: estructuraEmpresa.segundoApellidoRepresentante ? estructuraEmpresa.segundoApellidoRepresentante : '-'
            }
        };
        const resumen = this.calcularTotales();
        return(
            <Grid>
                <Row className="show-grid" style={{marginTop: '30px'}}>
                    <Col sm={6} md={3}>
                        <div className="font-col">
                            <Row><b>Datos Generales</b></Row>
                            <Row>Tipo de Persona <span>{datosBasicos.tipoPersona}</span></Row>
                            <Row>Naturaleza Juridica <span>{datosBasicos.naturalezaJuridica}</span></Row>
                            <Row>Código Actividad Economica <span>{datosBasicos.codigoActividadEconomica}</span></Row>
                            <Row>Tipo Aportante <span>{datosBasicos.tipoAportante}</span></Row>
                            <Row>Clase Aportante <span>{datosBasicos.claseAportante}</span></Row>
                            <Row>Correo Eléctronico <span>{datosBasicos.correoElectronico}</span></Row>
                        </div>
                    </Col>
                    <Col sm={6} md={3} style={{borderLeft: '1px solid #DDDDDD', marginLeft: '50px'}}>
                        <div className="font-col" style={{marginLeft: '50px'}}>
                            <Row><b>Representante Legal</b></Row>
                            <Row>Tipo Documento <span>{datosBasicos.RL.tipoDocumento}</span></Row>
                            <Row>Número Documento <span>{datosBasicos.RL.numeroDocumento}</span></Row>
                            <Row>Primer Nombre <span>{datosBasicos.RL.primerNombre}</span></Row>
                            <Row>Segundo Nombre <span>{datosBasicos.RL.segundoNombre}</span></Row>
                            <Row>Primer Apellido <span>{datosBasicos.RL.primerApellido}</span></Row>
                            <Row>Segundo Apellido <span>{datosBasicos.RL.segundoApellido}</span></Row>
                        </div>
                    </Col>
                    <Col sm={6} md={3} style={{borderLeft: '1px solid #DDDDDD', marginLeft: '50px'}}>
                        <div className="font-col" style={{marginLeft: '50px'}}>
                            <Row><b>Resumen SAT</b></Row>
                            <Row>Sedes <span>{resumen.totalSedes}</span></Row>
                            <Row>Centros de Trabajo <span>{resumen.totalCT}</span></Row>
                            <Row>Empleados <span>{resumen.totalEmpleados}</span></Row>
                        </div>
                    </Col>
                    <Col sm={6} md={3} style={{borderLeft: '1px solid #DDDDDD', marginLeft: '50px'}}>
                        <div className="font-col" style={{marginLeft: '50px'}}>
                            <Row><b>Resumen SURA</b></Row>
                            <Row>Sedes <span>{0}</span></Row>
                            <Row>Centros de Trabajo <span>{0}</span></Row>
                            <Row>Empleados <span>{0}</span></Row>
                        </div>
                    </Col>
                </Row>
            </Grid>
        );
    }

    calcularTotales() {
        const totalSedes = this.props.estructuraEmpresa.sedes.length;
        let totalCT = 0;
        let totalEmpleados = 0;
        if(totalSedes > 0) {
            this.props.estructuraEmpresa.sedes.forEach(sede => {
                totalCT += sede.centrosTrabajo.length;
                if(sede.centrosTrabajo.length > 0) {
                    sede.centrosTrabajo.forEach(ct => {
                        totalEmpleados += ct.empleados.length;
                    });
                }
            });
        }
        return {
            totalSedes: totalSedes,
            totalCT: totalCT,
            totalEmpleados: totalEmpleados
        };
    }
}

interface InformacionBasicaEmpresaProps {
    consecutivoConsulta : number,
    estructuraEmpresa?: EstructuraEmpresa,
    estructuraSuraEmpresa?: EstructuraSuraEmpresa
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/estructura_empresas/componentes/InformacionBasicaEmpresa.tsx